import { Component } from 'vue-property-decorator'
import { BaseForm } from '@/mixins/Base.tsx'
import { FormRenderServiceProxy } from '@/service-proxies/app-v2/dnc.service-proxies'
import { VNode } from 'vue'
const frsp = new FormRenderServiceProxy()
const CODE = 'DNC_RESOURCE'

@Component
export default class SearchForm extends BaseForm {
  created() {
    this.loadSchema()
  }

  async loadSchema() {
    try {
      const { schema } = await frsp.findFilterSchema(CODE)
      this.schema = schema
    } catch (e) {
      console.log(e.message)
    }
  }

  render(): VNode {
    return <d-form schema={this.schema} cols={1} ref="dForm" />
  }
}
